import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { updateEmailWithHpr, fetchUserEmail } from '../../actions/userActions';

function SendConsentWithHPR({ text, message, emailLabel, hprLabel, consent, setEmail, email, hprValue, updateEmailWithHpr, fetchUserEmail, redirectUrl }) {
  const [inputValue, setInputValue] = useState('');
  const [hprInputValue, setHprValue] = useState('');
  const [isValidEmail, setIsValidEmail] = useState(true);
  const [isValidHpr, setIsValidHpr] = useState(true);
  const [shouldRedirect, setShouldRedirect] = useState(false);
  useEffect(() => {
    if(setEmail)
      fetchUserEmail();
  }, [fetchUserEmail]);
  
  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };  

  const handleHprValueChange = (e) => {
    setHprValue(e.target.value);
  };


  const handleButtonClick = () => {
    // Validate email format
    const isValid = validateEmail(inputValue);
    setIsValidEmail(isValid);
      const isValidHpr = hprInputValue != "";
    setIsValidHpr(isValidHpr);
    if (isValid && isValidHpr) {
      // Handle valid email logic here
      console.log('Valid email:', inputValue);
      updateEmailWithHpr(inputValue, hprInputValue);
    } 
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  useEffect(() => {
    // Check if consent changes to true
    if (consent) {
      window.location.href = redirectUrl
    }
  }, [consent]);
  
  useEffect(() => {
    // Check if consent changes to true
    if (email) {
      setInputValue(email);
    }
  }, [email]);

  return (
      <div>
          {!consent ? (
              <div>
                  <div>
                      <label htmlFor="email-input">{emailLabel}</label>
                      <input
                          id="email-input"
                          type="text"
                          value={inputValue}
                          onChange={handleInputChange}
                         
                      />
                      {!isValidEmail && (
                          <p style={{ color: 'red' }}>
                              Invalid email format
                          </p>
                      )}
                  </div>

                  <div>
                      <label htmlFor="hpr-input">{hprLabel}</label>
                      <input
                          id="hpr-input"
                          type="text"
                          value={hprInputValue}
                          onChange={handleHprValueChange}
                          
                      />
                      {!isValidHpr && (
                          <p style={{ color: 'red' }}>
                              Official ID is required
                          </p>
                      )}
                  </div>

                  <button onClick={handleButtonClick}>
                      {text}
                  </button>
              </div>
          ) : (
              <p>{message}</p>
          )}
      </div>
  );
}

const mapStateToProps = (state) => {
  return {
    email: state.user.email,
    hprValue: state.user.hprValue,
    consent: state.user.consent,
    redirectUrl: state.landing.landing.RedirectUrl
  };
};

export default connect(mapStateToProps, { updateEmailWithHpr, fetchUserEmail })(SendConsentWithHPR);